<template>
  <el-dialog
    :visible.sync="isBookingRoomDialogOpened"
    title="Thông tin đặt phòng"
    width="80%"
    append-to-body
    :close-on-click-modal="false"
    @close="() => {}"
  >
    <BookingRoomForm
      v-if="isBookingRoomDialogOpened"
      ref="BookingRoomForm"
      :action="bookingFormAction(bookingRoomFormData.status)"
      :record-data="bookingRoomFormData"
      :is-disable="isDisable"
    ></BookingRoomForm>
    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex; gap: 10px; justify-content: flex-end"
    >
      <!-- <button
        v-if="bookingRoomFormAction == 'create'"
        class="btn primary small"
        @click="onCreateBookingRoom"
      >
        Thêm
      </button> -->
      <!-- v-show="bookingRoomFormData?.status === 1" -->
      <button class="btn primary small" @click="onUpdateBookingRoom">
        Cập nhật
      </button>
      <!-- <button class="btn pink small outline" @click="onDeleteBookingRoom">
        Xóa
      </button> -->
      <button
        class="btn primary small outline"
        @click="isBookingRoomDialogOpened = false"
      >
        Đóng
      </button>
    </span>
  </el-dialog>
</template>

<script>
import BookingRoomForm from '@/views/mci/group/components/BookingRoomForm.vue'

import {
  getBookingRoom,
  updateBookingRoom
} from '@/api/booking_service/booking'
import { executeCardRoomForCheckout } from '@/api/reception/card_service'
import { notifyError, notifySuccess } from '@/utils/toast'

export default {
  components: {
    BookingRoomForm
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    },
    isDisable: {
      type: Boolean,
      default: false
    },
    isCallApi: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bookingRoomFormData: null,
      oldNumOfFreeCard: null
    }
  },

  computed: {
    isBookingRoomDialogOpened: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  watch: {
    data(nv, ov) {
      if (nv) {
        this.oldNumOfFreeCard = nv?.num_of_free_card
        if (
          nv?.room_booking_id !== null &&
          nv?.room_booking_id !== undefined &&
          nv?.room_booking_id !== 0
        ) {
          this.fnGetBookingRoom(nv?.room_booking_id)
        } else if (nv?.id !== null && nv?.id !== undefined && nv?.id !== 0) {
          this.fnGetBookingRoom(nv?.id)
        }
        // this.bookingRoomFormData = nv
      }
    }
  },
  mounted() {},
  methods: {
    bookingFormAction(status) {
      if (status === 1) return 'edit'
      if (status === 2) return 'edit-checked-in'
      return null
    },
    async onUpdateBookingRoom() {
      const error = this.$refs.BookingRoomForm.validateForm()

      if (error !== null) {
        notifyError(error, true)
        return
      }
      const payload = this.$refs.BookingRoomForm.dehydrateForm()
      if (this.isCallApi) {
        if (this.bookingRoomFormData.id) {
          const success = await this.updateBookingRoom(
            this.bookingRoomFormData.id,
            payload
          )
          if (success) {
            // datnt - card service
            if (
              payload?.num_of_free_card &&
              payload?.num_of_free_card < this.oldNumOfFreeCard
            ) {
              // call api
              const response = await executeCardRoomForCheckout({
                idList: [this.bookingRoomFormData.id],
                type: 2
              })
              if (response?.is_error) {
                this.$message({
                  type: 'error',
                  message: 'Lỗi cập nhật khóa từ'
                })
              }
            }

            this.$emit('onUpdateBookingRoom')
          }
        }
      } else {
        this.$emit('onUpdateBookingRoom', payload)
      }

      // Object.assign(
      //   this.formData.booking_room[this.bookingRoomTableIndex],
      //   payload
      // )
      // // this.onCloseBookingRoomDialog()
      // this.$refs.BookingFormRoomTable.$refs.bookingRoomTable.gridOptions.api.refreshCells(
      //   {
      //     force: true
      //   }
      // )
    },

    onDeleteBookingRoom() {
      // this.formData.booking_room.splice(this.bookingRoomTableIndex, 1)
      // this.isBookingRoomDialogOpened = false
    },

    // handle api call
    fnGetBookingRoom(id) {
      if (id) {
        getBookingRoom(id)
          .then(res => {
            this.bookingRoomFormData = res.data
          })
          .catch(() => {
            this.isBookingRoomDialogOpened = false
            this.$message({
              type: 'error',
              message: 'Đã có lỗi xảy ra'
            })
          })
          .finally(() => {})
      }
    },

    async updateBookingRoom(id, payload) {
      return await updateBookingRoom(id, payload)
        .then(res => {
          notifySuccess(res?.message)
          return true
        })
        .catch(err => {
          notifyError(err?.response?.data?.message)
          return false
        })
    }
  }
}
</script>
